exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".record-filter[data-v-91c4e67e]{margin-bottom:4px}.queue-position[data-v-91c4e67e],.secondary-text[data-v-91c4e67e]{margin-top:4px;color:#909399;font-size:12px}.pagination[data-v-91c4e67e]{margin-top:16px;text-align:right}", ""]);

// exports
